import script from "./CurationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CurationPanel.vue?vue&type=script&setup=true&lang=js"

import "./CurationPanel.vue?vue&type=style&index=0&id=cfaf54ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfaf54ec"]])

export default __exports__